var jquery = require("jquery");
window.$ = window.jQuery = jquery;

$(document).ready(function () {
    changeSelectLanguage();
    enableTooltip();  
    $("#languageSelect").change(function () {       
        $('#frmChangeLanguage').submit();        
    })
});

function changeSelectLanguage() {
    var language = $("#languageSelect").val();
    if (language == "fr") {
        $("select option").html("<span>Anglais</span>");
        $("select option:selected").html("<span>Fran&ccedil;ais</span>");
    } else {
        $("select option").html("<span>French</span>");
        $("select option:selected").html("<span>English</span>");
    }
}

function enableTooltip() {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });
}

function nextKey() {
    $(".mfaInput").keyup(function () {        
        if (this.value.length == this.maxLength) {
            $(this).next('.mfaInput').focus();
        }
    });
}

window.getQRCode = function getQRCode() {
    var keyUri = $("#KeyUri").val();
    if (keyUri) {
        new QRCode(document.getElementById("qrCode"),
            {
                text: keyUri,
                width: 132,
                height: 132
            });
    }
}

window.passwordStrength = function passwordStrength(strength) {
    var password = document.getElementById('Password');
    var meter = document.getElementById('password-strength-meter');
    var text = document.getElementById('password-strength-text');

    const regularExpression = /(?=^.{12,50}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-!$%^&*()_+|~=`{}[:;<>?,.#\]])(?!.*\s).*$/;

    password.addEventListener('input', function () {
        var val = password.value;

        const digitsCheck = /\d/.test(val);
        const lowerCaseLettersCheck = /[a-z]+/.test(val);
        const capitalLettersCheck = /[A-Z]+/.test(val);
        const specialLettersCheck = /[-!$%^&*()_+|~=`{}[:;<>?,.#\]]/.test(val);
        const lengthCheck = val.length >= 12;
        const elPasswordLengthCondition = $("#PasswordLengthCondition");
        const elPasswordLettersCondition = $("#PasswordLettersCondition");
        const elPasswordDigitsAndSpecialCharactersCondition = $("#PasswordDigitsAndSpecialCharactersCondition");
        const elPasswordLengthConditionText = $("#PasswordLengthConditionText");
        const elPasswordLettersConditionText = $("#PasswordLettersConditionText");
        const elPasswordDigitsAndSpecialCharactersConditionText = $("#PasswordDigitsAndSpecialCharactersConditionText");
        let score = 0;
        let result = 0;
        if (elPasswordLengthCondition) {
            elPasswordLengthCondition.hide();
            elPasswordLettersCondition.hide();
            elPasswordDigitsAndSpecialCharactersCondition.hide();
            elPasswordLengthConditionText.removeClass("text-success");
            elPasswordLettersConditionText.removeClass("text-success");
            elPasswordDigitsAndSpecialCharactersConditionText.removeClass("text-success");
        }
        if (digitsCheck) score++;
        if (lowerCaseLettersCheck) score++;
        if (capitalLettersCheck) score++;
        if (specialLettersCheck) score++;
        if (lowerCaseLettersCheck && capitalLettersCheck && elPasswordLettersCondition) {
            elPasswordLettersCondition.show();
            elPasswordLettersConditionText.addClass("text-success");
        }
        if (specialLettersCheck || digitsCheck) {
            elPasswordDigitsAndSpecialCharactersCondition.show();
            elPasswordDigitsAndSpecialCharactersConditionText.addClass("text-success");
        }
        if (lengthCheck) {
            if (elPasswordLengthCondition) {
                elPasswordLengthCondition.show();
                elPasswordLengthConditionText.addClass("text-success");
            }
            score++;
        }
        if (score <= 2) result = 0;
        else if (score == 3) result = 1;
        else if (score == 4) result = 2;
        else if (score == 5) result = 3;

        if (regularExpression.test(val)) result = 4;

        // Update the password strength meter
        meter.value = result;

        // Update the text indicator
        if (val !== "") {
            text.innerHTML = strength[result];
        } else {
            text.innerHTML = "";
        }
    });
}
window.redirectPage = function redirectPage() {
    window.location.href = document.querySelector("meta[http-equiv=refresh]").getAttribute("data-url");
}
